import { atom } from "recoil"

export type AuthedUser = {
  email: string
  screenName?: string
  personaImageUrl?: string
  personaDescription?: string
  userId: number
  verified: boolean
  personaId?: number
}

export type AuthedUserUpdate = Partial<Omit<AuthedUser, "email" | "userId" | "verified">>

export const authedUserAtom = atom<AuthedUser | null>({
  key: "authedUserAtom",
  default: null
})
